import { render, staticRenderFns } from "./delete-button-with-confirmation.vue?vue&type=template&id=895a1378&"
import script from "./delete-button-with-confirmation.vue?vue&type=script&lang=js&"
export * from "./delete-button-with-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./delete-button-with-confirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports